import Corner from "./Corner";
import Content from "./Content";
import ColumnsList from "./ColumnsList";

interface HeaderProps {
    cellWidth: number;
    currentTimeOffset: any;
}

function Header({ cellWidth, currentTimeOffset, }: HeaderProps) {
    return (
        <>
            <Corner />

            <Content
                cellWidth={cellWidth}
                currentTimeOffset={currentTimeOffset}
            />

            <ColumnsList />
        </>
    );
}

export default Header;
